// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {Assessment, SearchParamRequest} from "@models";
import {VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";
import {SimAssessmentService} from "@services";

@Component({
	selector: "sim-assessment-template-chip-input",
	templateUrl: "./sim-assessment-template-chip-input.component.html",
	styleUrls: ["./sim-assessment-template-chip-input.component.scss"],
	standalone: false,
})
export class SimAssessmentTemplateChipInputComponent {
	@Input() assessmentTemplateFC: FormArray<FormControl<Assessment>>;
	@Input() label: string;
	@Input() placeholder: string;
	@Input() canSelectMultipleAssessments = false;

	optionSelected = output<Assessment>();

	autoCompleteData: VMAutoCompleteNormal<Assessment>[] = [];

	constructor(private _simAssessmentService: SimAssessmentService) {}

	reloadAutoCompleteData(searchString: string) {
		const searchParams: SearchParamRequest = {
			pageNumber: 0,
			pageSize: 100,
			sortAscending: true,
			sortColumn: "name",
			searchFilters: [{searchColumn: "name", searchTerms: [searchString]}],
		};
		this._simAssessmentService.getFilteredAssessments(searchParams).then((assessments) => {
			this.autoCompleteData = assessments.data.map((assessment) => ({
				displayName: assessment.name,
				value: assessment,
			}));
		});
	}
}
